import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      toast.error("Bitte gültige E-Mail eingeben");
      return;
    }
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      setSent(true);
      toast.success("Eingetragen — wir melden uns mit Updates");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Fehler beim Eintragen");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div data-testid="newsletter-success" className="flex items-center gap-2 text-sm text-green-400 mt-3">
        <CheckCircle2 size={14} /> Eingetragen! Wir melden uns.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="mt-3" data-testid="newsletter-form">
      <div className="eyebrow text-zinc-500 mb-2">Programm-Updates</div>
      <div className="flex gap-2">
        <input
          data-testid="newsletter-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="deine@email.de"
          required
          className="flex-1 bg-[#1a1a1a] border border-white/15 rounded-lg px-3 py-2 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:border-[#FFCC51]/50"
        />
        <button
          data-testid="newsletter-submit"
          type="submit"
          disabled={loading}
          className="px-3 py-2 rounded-lg bg-[#FFCC51] text-black font-display font-bold text-xs hover:bg-[#e6b53d] transition-colors disabled:opacity-50"
        >
          {loading ? <Loader2 className="animate-spin" size={12} /> : "Eintragen"}
        </button>
      </div>
    </form>
  );
};
